export { mockUserClient } from "./mocks/mocks";
// TODO(mijames): remove direct client exports from @kaggle/sdk and,
// instead, force consumers to use the react context
export { EventCategory } from "./analytics/EventCategory";
export { logger, Logger, reportEvent } from "./analytics/logger";
// In the future these are the only exports this module should expose
export { BothClients, bothClients, Clients, ClientsContext } from "./context";
export { featureFlags } from "./featureFlags";
export { AnalyticsClient } from "./legacyClients/analyticsClient/analyticsClient";
// Legacy client types required by library and app code
// These should be removed over time
export {
  ClientBlobBucketName as LegacyClientBlobBucketName,
  CreateNewBlobHandler as LegacyCreateNewBlobHandler,
  CreateNewBlobRequestDto as LegacyCreateNewBlobRequestDto,
  StartCreateNewBlobFileDto as LegacyStartCreateNewBlobFileDto,
} from "./legacyClients/blobFilesClient/blobFilesClient";
export {
  Competition as LegacyCompetition,
  CompetitionCategory as LegacyCompetitionCategory,
  CompetitionLeaderboardMember as LegacyCompetitionLeaderboardMember,
  CompetitionListTab as LegacyCompetitionListTab,
  CompetitionSortBy as LegacyCompetitionSortBy,
  HostSegment as LegacyHostSegment,
  SearchCompetitionsRequest as LegacySearchCompetitionsRequest,
  SearchCompetitionsResponse as LegacySearchCompetitionsResponse,
} from "./legacyClients/competitionsClient/competitionsClient";
export {
  DatasetFileTypeGroup as LegacyDatasetFileTypeGroup,
  DatasetJoinSuggestion as LegacyDatasetJoinSuggestion,
  DatasetJoinSuggestionType as LegacyDatasetJoinSuggestionType,
  DatasetLicenseGroup as LegacyDatasetLicenseGroup,
  DatasetListItem as LegacyDatasetListItem,
  DatasetSelectionGroup as LegacyDatasetSelectionGroup,
  DatasetSizeGroup as LegacyDatasetSizeGroup,
  DatasetSortBy as LegacyDatasetSortBy,
  DataSource as LegacyDataSource,
  DataSourceFilterType as LegacyDataSourceFilterType,
  DataSourceReference as LegacyDataSourceReference,
  DataSourceType as LegacyDataSourceType,
} from "./legacyClients/datasetsClient";
export { ResponseStatus as LegacyResponseStatus } from "./legacyClients/enums";
export {
  KernelLanguageFilter as LegacyKernelLanguageFilter,
  KernelsListSortType as LegacyKernelsListSortType,
  KernelsListViewType as LegacyKernelsListViewType,
  KernelTypeFilter as LegacyKernelTypeFilter,
  SearchKernelsRequest as LegacySearchKernelsRequest,
  SearchKernelsResponse as LegacySearchKernelsResponse,
} from "./legacyClients/kernelsClient/kernelsClient";
export { LegacyClients } from "./legacyClients/legacyClients";
export * from "./sdk";
export { getSessionTokenFromCookie, getSessionClaims } from "./sessionClaims";
export {
  setActiveEventsListener,
  clearActiveEventsListeners,
} from "./firebase/activeEvents";
export {
  AcceleratorType,
  ActiveEvent,
  KernelSessionActiveEvent,
} from "./firebase/types/activeEvents";
export { ensureClientInitialized } from "./firebase/firebase";
export { getCurrentUser } from "./utils";
